import React, { useState, useEffect } from "react";
import { Modal, Button, Switch, Checkbox, message } from "antd";
import {
  SafetyOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";

export default function ManagerSignModal({
  open,
  onCancel,
  onConfirm,
  company,
  signatoryConfig,
  managerName = "Phạm Thị Thu Lan",
  managerTitle = "Giám đốc",
}) {
  const [applySideStamp, setApplySideStamp] = useState(true);
  const [authorizedAgreed, setAuthorizedAgreed] = useState(true);

  const managerSignature = signatoryConfig?.managerSignature;
  const sealImage = signatoryConfig?.sealImage || company?.stampImage || null;

  useEffect(() => {
    if (open) {
      setAuthorizedAgreed(true);
    }
  }, [open]);

  const handleSubmit = () => {
    if (!managerSignature) {
      message.error("Doanh nghiệp chưa cấu hình chữ ký đại diện. Vui lòng mở cấu hình doanh nghiệp trước.");
      return;
    }

    if (!authorizedAgreed) {
      message.warning("Vui lòng xác nhận quyền đại diện ký duyệt văn bản!");
      return;
    }

    onConfirm({
      managerApprove: true,
      applySideStamp: Boolean(sealImage && applySideStamp),
      signedAt: new Date().toISOString(),
      managerName,
      managerTitle,
    });
  };

  return (
    <>
      <Modal
        open={open}
        onCancel={onCancel}
        width={560}
        destroyOnClose
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <SafetyOutlined style={{ color: "#dc2626", fontSize: 22 }} />
            <div>
              <div style={{ fontWeight: 800, fontSize: 16 }}>Duyệt hợp đồng & Ký đại diện</div>
              <div style={{ fontSize: 12, color: "#64748b", fontWeight: 400 }}>
                Đại diện người sử dụng lao động: <b>{managerName}</b> ({managerTitle})
              </div>
            </div>
          </div>
        }
        footer={[
          <Button key="cancel" onClick={onCancel}>
            Hủy bỏ
          </Button>,
          <Button
            key="submit"
            type="primary"
            icon={<CheckCircleOutlined />}
            style={{ background: "#dc2626", borderColor: "#dc2626", fontWeight: 700 }}
            onClick={handleSubmit}
          >
            {sealImage ? "Duyệt & Đóng dấu mộc đỏ" : "Duyệt & Ký điện tử"}
          </Button>,
        ]}
      >
        <div style={{ padding: "8px 0" }}>
          {/* Chữ ký và con dấu đã được cấu hình trước */}
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: 700, fontSize: 13, color: "#1e293b", marginBottom: 6 }}>
              Chữ ký đại diện và con dấu:
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 12, padding: 10, border: "1px solid #cbd5e1", borderRadius: 8, background: "#f8fafc" }}>
              {managerSignature ? (
                <img src={managerSignature} alt="Chữ ký người đại diện" style={{ height: 48, maxWidth: 170, objectFit: "contain" }} />
              ) : (
                <span style={{ fontSize: 12, color: "#dc2626" }}>Chưa có chữ ký</span>
              )}
              {sealImage ? (
                <img src={sealImage} alt="Con dấu công ty" style={{ width: 56, height: 56, objectFit: "contain" }} />
              ) : (
                <span style={{ fontSize: 12, color: "#64748b" }}>Chưa tải lên con dấu mộc đỏ</span>
              )}
              <span style={{ fontSize: 12, color: "#15803d", fontWeight: 700, marginLeft: "auto" }}>Sẵn sàng áp dụng</span>
            </div>
          </div>

          {/* Xem trước con dấu đè 1/3 chữ ký */}
          <div
            style={{
              border: "1px solid #fed7aa",
              background: "#fffaf0",
              borderRadius: 8,
              padding: "12px 16px",
              marginBottom: 16,
            }}
          >
            <div style={{ fontWeight: 700, fontSize: 12, color: "#c2410c", marginBottom: 8 }}>
              👁 XEM TRƯỚC VĂN BẢN KÝ DUYỆT:
            </div>
            <div
              style={{
                position: "relative",
                height: 120,
                background: "#fff",
                border: "1px solid #e2e8f0",
                borderRadius: 6,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
              }}
            >
              {/* Vị trí chữ ký */}
              <div style={{ position: "relative", zIndex: 1 }}>
                {managerSignature ? (
                  <img src={managerSignature} alt="Manager preview" style={{ height: 60, maxWidth: 180 }} />
                ) : (
                  <span style={{ color: "#94a3b8" }}>(Chữ ký Giám đốc)</span>
                )}
                {/* Vị trí con dấu đè 1/3 chữ ký (nếu có con dấu) */}
                {sealImage && (
                  <img
                    src={sealImage}
                    alt="Seal overlay"
                    style={{
                      position: "absolute",
                      left: -35,
                      top: -15,
                      width: 90,
                      height: 90,
                      zIndex: 2,
                      opacity: 0.9,
                      transform: "rotate(-8deg)",
                    }}
                  />
                )}
              </div>
            </div>
            <div style={{ fontSize: 11, color: "#64748b", marginTop: 6 }}>
              {sealImage ? "* Con dấu mộc đỏ sẽ đóng trùm 1/3 góc trái chữ ký theo đúng quy định Nghị định 30/2020/NĐ-CP." : "* Văn bản sẽ được đóng chữ ký điện tử của người đại diện."}
            </div>
          </div>

          {/* Tùy chọn đóng dấu giáp lai */}
          {sealImage && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14, padding: "8px 12px", background: "#f8fafc", borderRadius: 6 }}>
              <div>
                <span style={{ fontWeight: 600, fontSize: 13, color: "#1e293b" }}>Đóng dấu giáp lai mép phải khi in:</span>
                <div style={{ fontSize: 11, color: "#64748b" }}>Tự động đóng mộc đỏ ở mép phải các trang sau trang 1</div>
              </div>
              <Switch checked={applySideStamp} onChange={setApplySideStamp} />
            </div>
          )}

          {/* Cam kết tính hợp pháp */}
          <div style={{ marginTop: 10 }}>
            <Checkbox checked={authorizedAgreed} onChange={(e) => setAuthorizedAgreed(e.target.checked)}>
              <span style={{ fontSize: 12, color: "#334155" }}>
                Tôi cam kết có đầy đủ thẩm quyền đại diện pháp luật của Công ty để phê duyệt và ban hành hợp đồng này.
              </span>
            </Checkbox>
          </div>
        </div>
      </Modal>
    </>
  );
}
